import React from 'react';
import JournalStatusReport from '../components/JournalStatusReport/JournalStatusReport';

const JournalStatus = () => {
    return (
        <JournalStatusReport>
            <JournalStatusReport.Header />
            <JournalStatusReport.Controls />
            <JournalStatusReport.InputArea />
            <JournalStatusReport.ProgressSection />
            <JournalStatusReport.HelpModal />
        </JournalStatusReport>
    );
};

export default JournalStatus;
